import { useCallback } from 'react';
import { useSendMessage } from 'crustate/react';
import { addMessage } from '@crossroads/shop-state/messages';
import { addItem } from '@crossroads/shop-state/quote';

var useAddToCartSimple = function useAddToCartSimple(product) {
  var sendMessage = useSendMessage();
  return useCallback(function (qty) {
    if (qty === void 0) {
      qty = 1;
    }
    return sendMessage(addItem({
      buyRequest: product.buyRequest
    }, qty));
  }, [sendMessage, product]);
};
var useAddToCartConfig = function useAddToCartConfig(product) {
  var sendMessage = useSendMessage();
  return useCallback(function (selected, qty) {
    if (qty === void 0) {
      qty = 1;
    }
    var attribute = product.options.attributes[0];
    if (selected && selected.buyRequest) {
      return sendMessage(addItem({
        buyRequest: selected.buyRequest
      }, qty));
    }
    return sendMessage(addMessage({
      translationKey: "errorProductNotChosenVariant",
      variable: {
        attributeLabel: attribute.label.toLowerCase()
      }
    }, "error"));
  }, [sendMessage, product]);
};
var useAddToCartCustomOptions = function useAddToCartCustomOptions(product) {
  var sendMessage = useSendMessage();
  return useCallback(function (customOptions, qty) {
    if (qty === void 0) {
      qty = 1;
    }
    if (!product.customOptions || product.customOptions.length === 0) {
      return;
    }
    return sendMessage(addItem({
      buyRequest: product.buyRequest,
      customOptions: customOptions
    }, qty));
  }, [sendMessage, product]);
};
var useAddToCartBundle = function useAddToCartBundle(product) {
  var sendMessage = useSendMessage();
  return useCallback(function (options, qty) {
    if (qty === void 0) {
      qty = 1;
    }
    var bundleOptions = Object.keys(options).map(function (x) {
      return {
        optionId: x,
        selectionId: options[x]
      };
    });
    return sendMessage(addItem({
      buyRequest: product.bundleBuyRequestBase || "",
      bundleOptions: bundleOptions
    }, qty));
  }, [sendMessage, product]);
};

export { useAddToCartBundle, useAddToCartConfig, useAddToCartCustomOptions, useAddToCartSimple };
//# sourceMappingURL=add-to-cart-hooks.js.map
